import { observer } from "mobx-react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Header } from "../../components/Header";
import { HOME, SCANNER } from "../../constants/routes";
import supervisorStore from "../../stores/SupervisorStore";
import qrScannerImage from "../../assets/images/qr-scanner.png";
import translationsStore from "../../stores/TranslationsStore";
import "./Home.scss";
import {
  HOME_GET_HELP,
  HOME_SCAN_TESTKIT,
  HOME_SUPERVISE_TEST,
} from "../../constants/translationKeys";
import IconQR from "../../assets/icons/qr-icon.png";
import historyStore from "src/stores/HistoryStore";

const GET_HELP_LINK = "info@pass.me";
const GET_HELP_SUBJECT = "Help with app";

const HomePage = () => {
  const history = useHistory();
  const supervisor = supervisorStore.supervisor!;
  const translations = translationsStore.translations;
  useEffect(() => {
    history.replace(HOME);
    historyStore.history = history;
  }, [history]);

  const scan = (isTestkit: boolean) => {
    supervisorStore.testkit = isTestkit;
    history.push(SCANNER);
  }

  return (
    <div className="layout-column flex">
      <Header />
      <div className="page-container flex">
        <h2>{`${supervisor.firstName} ${supervisor.lastName}`}</h2>
        <h5>{supervisor.id}</h5>

        <img className="onboarding-image" src={qrScannerImage} alt="Missing." />

        <div className="spacer"></div>
        <button className="button filled-button home-button" onClick={() => scan(true)}>
          <img className="qr-icon" src={IconQR} alt="" />
          {translations[HOME_SCAN_TESTKIT]}
        </button>
        <button
          className="button filled-button home-button"
          onClick={() => scan(false)}
        >
          <img className="qr-icon" src={IconQR} alt="" />
          {translations[HOME_SUPERVISE_TEST]}
        </button>
        <button
          className="button text-button"
          onClick={() => {
            window.open(`mailto:${GET_HELP_LINK}?subject=${GET_HELP_SUBJECT}`);
          }}
        >
          {translations[HOME_GET_HELP]}
        </button>
      </div>
    </div>
  );
};

export default observer(HomePage);
